import React, { useState } from 'react';
import { modalStyles as styles } from './modalStyles';
import { formatAddress } from '../addressUtils';

const API_BASE = process.env.REACT_APP_API_URL;

export default function CustomerRmaModalReady({ rma, onClose, onSave }) {
  // savedAddress holds the confirmed address — set after a successful submit or
  // pre-populated from the prop if one already exists. This ensures the
  // confirmation view renders immediately after submit without relying on the
  // parent re-rendering with an updated rma prop.
  const existingAddress = rma.shippingAddress?.recipientName ? rma.shippingAddress : null;
  const [savedAddress, setSavedAddress] = useState(existingAddress);
  const [address, setAddress] = useState({
    recipientName: existingAddress?.recipientName || '',
    streetAddress: existingAddress?.streetAddress || '',
    city: existingAddress?.city || '',
    region: existingAddress?.region || '',
    postalCode: existingAddress?.postalCode || '',
    country: existingAddress?.country || '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => {
    setAddress(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleConfirm = () => {
    setSubmitting(true);
    setError('');
    fetch(`${API_BASE}/rma/${rma._id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shippingAddress: address }),
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to save address');
        return res.json();
      })
      .then(updated => {
        setSavedAddress(address);
        if (typeof onSave === 'function') onSave(updated);
      })
      .catch(err => {
        console.error('Failed to save address', err);
        setError('Failed to save address. Please try again.');
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2>Awaiting Shipping</h2>
        {savedAddress ? (
          <>
            <p>Repair complete. We have recorded your shipping address:</p>
            <div style={{ whiteSpace: 'pre-line' }}>
              {formatAddress(savedAddress)}
            </div>
            <p>North Invent will attach a tracking number once the device is shipped.</p>
            <button onClick={onClose} style={styles.button}>Close</button>
          </>
        ) : (
          <>
            <p>Repair complete. Please provide the shipping address for the return shipment.</p>
            <input
              name="recipientName"
              placeholder="Recipient Name"
              value={address.recipientName}
              onChange={handleChange}
              style={styles.input}
              disabled={submitting}
            />
            <input
              name="streetAddress"
              placeholder="Street Address"
              value={address.streetAddress}
              onChange={handleChange}
              style={styles.input}
              disabled={submitting}
            />
            <input
              name="city"
              placeholder="City / Town"
              value={address.city}
              onChange={handleChange}
              style={styles.input}
              disabled={submitting}
            />
            <input
              name="region"
              placeholder="Region / State / Province"
              value={address.region}
              onChange={handleChange}
              style={styles.input}
              disabled={submitting}
            />
            <input
              name="postalCode"
              placeholder="Postal Code / ZIP"
              value={address.postalCode}
              onChange={handleChange}
              style={styles.input}
              disabled={submitting}
            />
            <input
              name="country"
              placeholder="Country"
              value={address.country}
              onChange={handleChange}
              style={styles.input}
              disabled={submitting}
            />
            {error && <p style={{ color: '#f87171', margin: '0.25rem 0' }}>{error}</p>}
            <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.5rem' }}>
              <button onClick={handleConfirm} style={styles.button} disabled={submitting || !address.recipientName.trim()}>
                {submitting ? 'Saving…' : 'Submit Address'}
              </button>
              <button onClick={onClose} style={styles.buttonAlt} disabled={submitting}>Cancel</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

